(function(root, factory) {
    'use strict';
    if (typeof exports === 'object') {
        // CommonJS
        module.exports = factory(require('js-cookie'));
    } else {
        // Global Variables
        root.UEM = root.UEM || {};
        root.UEM.ua = factory();
    }
}(this, function(cookie) {
    'use strict';

    // 兼容同构
    if (typeof window === 'undefined') return {};

    var out = {},
        ua = window.navigator.userAgent.toLowerCase(),
        pf = '',
        os = '',
        sessionId = '';

    /**
     * uc mini iflow ?
     */
    out.isUcMiniFlow = function() {
     return ua.indexOf('ucminiiflow') >= 0;
    };

    /**
     * calculate pf
     */
    if (ua.indexOf('uclite') >= 0 || getQueryParam('pf') === '218' || getUcParamsFromHtml('pf') === '218') {
        pf = 'UCLITE';
    } else if (getQueryParam('pf') === '139' || getQueryParam('pf') === '140' || getQueryParam('pf') === '142' || out.isUcMiniFlow()) {
        pf = 'UC_MINI';
    } else if (ua.indexOf('dingtalk') >= 0) {
         // 钉钉使用的是UC内核，ua中存在ucbrowser，需要优先判断
        pf = 'DINGTALK';
    } else if (ua.indexOf('ucbrowser') >= 0 && ua.indexOf('uws/') === -1) {
        // uws: UC WebView Service，用于区分使用UC内核的阿里系App
        pf = 'UC';
    } else if (ua.indexOf('ucnewsapp') >= 0 || ua.indexOf('ucnewsintl') >= 0) {
        pf = 'UCNEWS';
    } else if (ua.indexOf('micromessenger') >= 0) {
        pf = 'WECHAT';
    } else if (ua.indexOf('youku/') >= 0) {
        pf = 'YOUKU';
    } else if (new RegExp('qq/\\d+\\.\\d+\\.\\d+\\.\\d+', 'i').test(ua)) {
        pf = 'QQ';
    } else if (new RegExp('weibo__\\d+\\.\\d+\\.\\d+', 'i').test(ua)) {
        pf = 'WEIBO';
    } else if (ua.indexOf('quark') >= 0) {
        pf = 'QUARK';
    } else if (ua.indexOf(';fbav/') >= 0) {
        pf = 'FACEBOOK';
    } else {
        pf = 'OTHERS';
    }

    function getUcParamsFromHtml (param) {
        // cuttle公参下发
        if (window.__UC_PARAMS__) {
            return __UC_PARAMS__[param]
        }
    }

    // jssdk get pf
    out.getUcParamsFromJssdk = function (paramStr) {
        if (!window.ucapi || !window.ucapi.biz || !window.ucapi.biz.ucparams) return ''
        ucapi.biz.ucparams({
            params:"", //公参(可选)，支持所有url公参，如"dnnivebichfr"
            isHttps: true, //是否要https的公参(可选)，https的公参不用无线保镖加密，默认为false
            ext:[],//扩展参数(可选)，sla: 系统语言
            success: function(data){
            // data.dn =
            // data.fr =
            // data.sla =
                return data
            },
            fail: function(data){
            // data: {"errCode":1, "errMsg":"ACCESS_DENY"} //参考错误码定义
            }
        });
    }

    /**
     * useragent platform
     */
    out.pf = pf;

    /**
     * whether is ios system
     */
    out.isIOS = function() {
        // Broccoli 下发公参判断，避免自定义 UA 的影响
        if (window.__UC_PARAMS__ && window.__UC_PARAMS__.fr) {
            return window.__UC_PARAMS__.fr === 'iphone';
        }

        if (pf === 'UC') {
            try {
                var match = /&fr=([^&]*)/.exec(window.location.search);
                if (match[1] ==='android') {
                    return false;
                } else if (match[1] ==='iphone') {
                    return true;
                }
            } catch(e){}
        }
        return /\(i[^;]+;( U;)? CPU.+Mac OS X/i.test(ua);
    };

    /**
     * current os
     */
    if (out.isIOS()) {
        os = 'IOS';
    } else if (ua.indexOf('android') > 1) {
        os = 'ANDROID';
    } else {
        os = 'OTHERS';
    }
    out.os = os;

    var SESSION_ID_LENGTH = 24;

    // var OMELETTE_SESSION_ID_LENGTH = 36; // EGG-OMELETTE生成的sessionid长度
    var BROCCOLI_SESSION_ID = 'b-user-id';

    /**
     * get session id
     */
    out.getSessionId = function() {
        try {
            var key = 'UEM_SESSION_ID';
            sessionId = sessionId || window.localStorage.getItem(key);
            if (sessionId) {
                // 为兼容正在线上的活动，BROCCOLI 中下发的SESSION ID设置为全局主域
                try {
                    cookie.set(BROCCOLI_SESSION_ID, sessionId, { domain: 'uc.cn' });
                } catch (error) {
                    console.error(error);
                }
                return sessionId;
            } else {
                sessionId = generateSessionId();
                window.localStorage.setItem(key, sessionId);
                return sessionId;
            }
        } catch (e) {
            return '';
        }
    };

    /**
     * generate session id
     */
    function generateSessionId() {
        var broccoliSID = cookie.get(BROCCOLI_SESSION_ID);
        if (broccoliSID) {
            cookie.set(BROCCOLI_SESSION_ID, broccoliSID, { domain: 'uc.cn' });
            return broccoliSID;
        }
        var sessionId = (+new Date() + '').substr(2, 10);
        while (sessionId.length < SESSION_ID_LENGTH) {
            sessionId += parseInt(Math.random() * 10, 10);
        }
        return sessionId;
    }

    out.getSessionId();

    /**
     * get uc version string
     */
    out.getUCVersion = function() {
        var match = out.isUcMiniFlow() ? /ucminiiflow\/([^\s]*)/.exec(ua) : /ucbrowser\/([^\s]*)/.exec(ua);
        if (pf === 'UC') {
            try {
                var matchSearch = /&ve=([^&]*)/.exec(window.location.search);
                if (matchSearch && matchSearch.length ===2 && matchSearch[1].length > 0) {
                    match = matchSearch;
                }
            } catch(e){}
        }
        return match && match.length === 2 ? match[1] : '';
    };

    /**
     * is uc latest version
     */
    out.isUCLatestVersion = function(latestVersion) {
        var curVersion = out.getUCVersion();
        return compareVersion(curVersion, latestVersion);
    };

    /**
     * get ucnews version string
     */
    out.getUCNewsVersion = function() {
        var match = /ucnews(app|intl)\/([^\s]*)/.exec(ua);
        return match && match.length === 3 ? match[2] : '';
    };

    /**
     * is uc latest version
     */
    out.isUCNewsLatestVersion = function(latestVersion) {
        var curVersion = out.getUCNewsVersion();
        return compareVersion(curVersion, latestVersion);
    };

    function compareVersion(curVersion, latestVersion) {
        if (!curVersion.length) {
            return false;
        }
        var curVersionArr = curVersion.split('.');
        var latestVersionArr = latestVersion.split('.');
        var cmpBit = 0;
        var tmpLength = latestVersionArr.length > curVersionArr.length ? curVersionArr.length : latestVersionArr.length;
        while (cmpBit < tmpLength) {
            if (parseInt(curVersionArr[cmpBit], 10) < parseInt(latestVersionArr[cmpBit], 10)) {
                return false;
            }
            if (parseInt(curVersionArr[cmpBit], 10) > parseInt(latestVersionArr[cmpBit], 10)) {
                return true;
            }
            ++cmpBit;
        }
        return true;
    }
    out.compareVersion = compareVersion;

    /**
     * 获取 url 上的 search 参数值
     * @param {string} key - 参数名
     * @param {string} url - 被查找的 url，默认为当前的 location
     */
    function getQueryParam(key, url) {
        url = url || location.search;
        var hashIndex = url.indexOf('#'),
            keyMatches;
        if (hashIndex > 0) {
            url = url.substr(0, hashIndex);
        }
        keyMatches = url.match(new RegExp('[?|&]' + encodeURIComponent(key) + '=([^&]*)(&|$)'));
        if(keyMatches && keyMatches[1]==='%s'){
            return keyMatches[1];
        }else{
            return keyMatches ? decodeURIComponent(keyMatches[1]) : '';
        }
    }

    out.isPC = function() {
      var userAgentInfo = window.navigator.userAgent;
      var Agents = new Array('Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod');
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) { flag = false; break; }
      }
      return flag;
    };

    return out;

}));
